import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  Typography,
} from '@mui/material'
import { styled } from '@mui/system'
import { StepIconProps } from '@mui/material/StepIcon'
import { Check } from '../assets/svgs'

const ThemedConnector = styled(StepConnector)(({ theme }) => ({
  marginLeft: 15,
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.common.white,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.secondary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.common.white,
    padding: 0,
    minHeight: '8px',
  },
}))

const ThemedIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
  ({ theme, ownerState }) => ({
    color: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    '& .QontoStepIcon-completedIcon': {
      display: 'flex',
      justifyContent: 'center',
      width: 32,
      height: 32,
      padding: '1.0rem',
      borderRadius: '50%',
      color: theme.palette.primary[600],
      borderColor: theme.palette.secondary.main,
      backgroundColor: theme.palette.secondary.main,
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      borderStyle: 'solid',
      borderWidth: '2px',
      color: theme.palette.common.white,
      borderColor: theme.palette.common.white,
      width: 32,
      height: 32,
      borderRadius: '50%',
      fontWeight: 'bold',
    },
  })
)

function QontoStepIcon(props: StepIconProps, index) {
  const { active, completed, className } = props

  return (
    <ThemedIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <Typography className="QontoStepIcon-circle">{index + 1}</Typography>
      )}
    </ThemedIconRoot>
  )
}

const ThemedStepLabel = styled(StepLabel)(({ theme }) => ({
  padding: '0.4rem 0rem',
  '.MuiStepLabel-label': {
    fontSize: '1.8rem !important',
    color: `${theme.palette.common.white} !important`,
  },
  '.Mui-completed': {
    opacity: 0.6,
    textDecoration: `line-through`,
  },
}))

export const VerticalStepper = ({ steps, currentStep }) => {
  return (
    <Stepper
      orientation="vertical"
      activeStep={currentStep}
      connector={<ThemedConnector />}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <ThemedStepLabel
            StepIconComponent={(props: StepIconProps) =>
              QontoStepIcon(props, index)
            }
          >
            {label}
          </ThemedStepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
